import { render, staticRenderFns } from "./dashboard-tinyemail.vue?vue&type=template&id=3581f109"
import script from "./dashboard-tinyemail.vue?vue&type=script&lang=js"
export * from "./dashboard-tinyemail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports